export const splitByLineBreaks = (text?: string): string[] => {
  if (!text) return [];
  const lines = text.split(/\r?\n/);
  return lines.map((line) => line.trim()).filter((line) => line.length > 0);
};

export const capitalize = (text: string) => {
  return text
    .split(" ")
    .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
    .join(" ");
};

export const formatPhoneNumber = (phoneNumber?: string | null): string => {
  if (!phoneNumber) {
    return "";
  }
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Handle numbers with country code (11 digits or more)
  if (cleaned.length >= 11) {
    return `${cleaned.slice(0, 1)}-${cleaned.slice(1, 4)}-${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`;
  }

  // Handle numbers without country code (10 digits)
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }

  // Return original input if it doesn't match expected formats
  return phoneNumber;
};

export interface Address {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
}

export const formatAddress = (address?: Address) => {
  if (!address) return "";

  const segment1 =
    `${address.line1 || ""}${address.line2 ? ` ${address.line2}` : ""}`.trim();
  const segment2 = `${address.city || ""}`.trim();
  const segment3 = `${address.state || ""} ${address.zip || ""}`.trim();
  return [segment1, segment2, segment3].filter(Boolean).join(", ");
};

export const formatAddressLine = (address: Address) => {
  return `${address.line1 || ""}${address.line2 ? ` ${address.line2}` : ""}`.trim();
};

export const formatCityStateZip = (address: Address) => {
  return `${address.city || ""}, ${address.state || ""} ${address.zip || ""}`.trim();
};

export const formatAddressIntoLines = (address: Address) => {
  return [formatAddressLine(address), formatCityStateZip(address)];
};

export const ensureTrailingZero = (value: string): string => {
  if (Number.isNaN(Number(value))) {
    return value;
  }

  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 1,
  });
};
